import { useEffect, useState } from "react";
import ScrollableReviewDialog from "./ScrollableReviewDialog";
import AnnualClientActivityReviewContent, {
    buildAnnualReviewPayload,
    normalizeAnnualReviewStatus,
} from "./AnnualClientActivityReviewContent";

const AnnualClientActivityReview = ({
    open,
    clientId,
    clientName,
    canWriteClientServices,
    canDeleteClientServices,
    onCompleted,
}) => {
    const [isDismissed, setIsDismissed] = useState(false);

    useEffect(() => {
        if (open) setIsDismissed(false);
    }, [clientId, open]);

    if (!open || isDismissed) return null;

    return (
        <ScrollableReviewDialog
            onClose={() => {
                if (!canWriteClientServices) setIsDismissed(true);
            }}
        >
            <AnnualClientActivityReviewContent
                key={clientId}
                clientId={clientId}
                clientName={clientName}
                canWriteClientServices={canWriteClientServices}
                canDeleteClientServices={canDeleteClientServices}
                onRequestClose={() => setIsDismissed(true)}
                onCompleted={(outcome) =>
                    onCompleted?.(
                        outcome.completionType === "confirm"
                            ? outcome.response?.data ?? outcome.response
                            : outcome.response,
                    )
                }
            />
        </ScrollableReviewDialog>
    );
};

export { buildAnnualReviewPayload, normalizeAnnualReviewStatus };
export default AnnualClientActivityReview;
